import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import HeadingForDashboardReusable from "../../../../reusable-components/headings/HeadingForDashboardReusable";
import { NOC_PRIMARY } from "../../../../utilities/constants/colors";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const NocReportPurposeGraph = ({ data }) => {
  const entries = Object.entries(data || {});

  const labels = entries.map(([key]) =>
    key
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" "),
  );

  const values = entries.map(([, value]) => Number(value) || 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: "NOC Count",
        data: values,
        backgroundColor: NOC_PRIMARY,
        hoverBackgroundColor: NOC_PRIMARY,
        hoverOpacity: 0.85,
        borderRadius: 6,
        maxBarThickness: 28,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: "NOC by Purpose",
        color: NOC_PRIMARY,
        font: { size: 14, weight: "600" },
        padding: { bottom: 16 },
      },
      tooltip: {
        backgroundColor: NOC_PRIMARY,
        padding: 10,
        cornerRadius: 6,
        callbacks: {
          label: (ctx) => ` ${ctx.parsed.y.toLocaleString("en-IN")}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#64748b", font: { size: 11 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: "rgba(0, 29, 49, 0.08)" },
        ticks: { color: "#64748b", font: { size: 11 }, precision: 0 },
      },
    },
  };

  return (
    <div>
      <HeadingForDashboardReusable
        title="NOC by Purpose"
        description="Overview of NOC applications categorized by their respective purposes."
      />
      <div className="w-full rounded-xl border border-slate-200 bg-white p-5 dark:border-slate-800 dark:bg-slate-900">
        <div className="h-72 w-full">
          <Bar data={chartData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default NocReportPurposeGraph;
